export { default } from "./AcceptChangeSchoolTerm";
